import { FirebaseApp, initializeApp } from "firebase/app";
import { getAuth, signOut, signInWithCustomToken } from "firebase/auth";
import { getFirestore, QueryConstraint, where } from "firebase/firestore";
import moment from "moment";
import { getToken } from "./api/users";
import { isOk } from "./result";
import { FirebaseSettings } from "./models/Settings";

class Firebase {
  app: FirebaseApp = {} as FirebaseApp;
  firestore = {} as any;

  async init(settings: FirebaseSettings): Promise<void> {
    const { clientEmail, ...appSettings } = settings;
    this.app = initializeApp(appSettings);
    const auth = getAuth(this.app);
    this.firestore = getFirestore(this.app);
    console.info("Firebase project:", settings.projectId, "as", clientEmail);

    try {
      const result = await getToken();
      if (!isOk(result) || !result.value) {
        console.error("Failed to get Firebase custom token", result);
        return;
      }
      await signInWithCustomToken(auth, result.value);
      console.info("Firebase signed in as", auth.currentUser?.uid);
    } catch (error) {
      console.error("Firebase auth failed", error);
    }
  }

  logOut(): Promise<any> {
    const auth = getAuth(this.app);
    return signOut(auth);
  }
}

export const logFirestoreError = (collectionName: string) => (error: Error) => {
  console.error(`Firestore listener failed (${collectionName}):`, error);
};

export const sameId = (a?: string, b?: string) =>
  !!a && !!b && a.toLowerCase() === b.toLowerCase();

export const includesStoreId = (ids: string[], storeId?: string) =>
  !!storeId && ids.some(id => sameId(id, storeId));

export const firebaseToday = () => moment().format("YYYY-MM-DD");

export const dateAndTenantConstraints = (
  stores: { cluster?: { id?: string } }[]
): QueryConstraint[] => {
  const constraints: QueryConstraint[] = [where("Date", "==", firebaseToday())];
  const tenantIds = [
    ...new Set(
      stores.map(s => s.cluster?.id).filter((id): id is string => !!id)
    )
  ];
  if (tenantIds.length === 1) {
    constraints.push(where("TenantId", "==", tenantIds[0]));
  } else if (tenantIds.length > 1 && tenantIds.length <= 10) {
    constraints.push(where("TenantId", "in", tenantIds));
  }
  return constraints;
};

export const firebase = new Firebase();
